import * as types from '../../actions/actiontypes';
import initialstate from '../initialstate';
import {HttpStatusCodes} from '../../util/uiconstants';
import Utility from '../../util/utilityfunctions';

export default function materialityReducer(state = initialstate.materiality, action) {
	switch (action.type) {
		case types.GET_MATERIALITY:
			return Utility.normalize(action.response);
		case types.UPDATE_MATERIALITY: {
			const {response, responseObj} = action;

			if (responseObj.status === HttpStatusCodes.Ok) {
				const updatedMateriality = {
					...state.byId[response.id],
					...response,
					basisAdjustedAmount: response?.basisAdjustedAmount,
					otherBasisDescription: response?.otherBasisDescription
				};

				const newState = Utility.safeNormalize(updatedMateriality, state, undefined, true);

				return newState;
			}

			return state;
		}
		case types.CREATE_MATERIALITY: {
			const {response} = action;

			const newState = Utility.safeNormalize(response, state, undefined, true);

			return newState;
		}

		case types.UPDATE_MATERIALITY_ADJUSTED_BASIS: {
			const {materialityId, basisAdjustedAmount} = action;

			const updatedMateriality = {
				...state.byId[materialityId],
				basisAdjustedAmount
			};

			const newState = Utility.safeNormalize(updatedMateriality, state, undefined, true);

			return newState;
		}
		case types.UPDATE_MATERIALITY_STATE_BY_ID: {
			const {materialityId, data} = action;

			const updateMateriality = {
				...state.byId[materialityId],
				suggestedTEPercent: data.suggestedTEPercent
			};

			const newState = Utility.safeNormalize(updateMateriality, state, undefined, true);

			return newState;
		}
		default:
			return state;
	}
}
